import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-view-zone-list',
  templateUrl: './view-zone-list.component.html',
  styleUrls: ['./view-zone-list.component.scss']
})
export class ViewZoneListComponent implements OnInit {

  public zoneForm: FormGroup;
  public nodalPoints: any[] = [];

  public fieldOptions = {
    branch: []
  };

  public branchInformation: any[] = [];
  public nodalID: string;

  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public route: ActivatedRoute,
  ) {
    this.route.paramMap.subscribe((params: any) => {
      this.nodalID = params.params.zoneID;
    });
  }

  ngOnInit(): void {
    this.loadZoneForm();
    this.getBranchList();
    if (this.nodalID) {
      this.loadZoneDetails();
    }
  }

  loadZoneForm() {
    this.zoneForm = new FormGroup({
      zoneName: new FormControl({ value: '', disabled: true }, [Validators.required]),
      branch: new FormControl({ value: '', disabled: true }, [Validators.required]),
    });
  }

  /* Branch list */
  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status === 'success') {
        this.branchInformation = res.data || [];
        this.addBranchOptions();
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  addBranchOptions() {
    this.fieldOptions.branch = [];
    if (this.branchInformation && this.branchInformation.length > 0) {
      this.branchInformation.filter((e) => {
        if (!(e?.isNodal || e?.isNodalBranch || e?.nodalBranch)) {
          return;
        }
        const option = { name: e.branchName, value: e.branchID };
        this.fieldOptions.branch.push(option);
      });
    }
  }

  loadZoneDetails() {
    const obj = { nodalID: this.nodalID };
    this.api.transportManagerZoneList(obj).then((res: any) => {
      if (res && res.status === 'success') {
        let zone: any = null;

        if (Array.isArray(res.data)) {
          zone = res.data.find((z: any) => (z.nodalID || z.zoneID) === this.nodalID) || res.data[0];
        } else {
          zone = res.data;
        }

        if (zone) {
          this.patchZoneForm(zone);
        } else {
          this.swal.swalFunction('error', 'Error', 'Zone details not found.', 3000);
        }
      } else {
        this.swal.swalFunction('error', 'Error', 'Zone details not found.', 3000);
      }
    }).catch((err) => {
      console.log(err);
      this.swal.swalFunction('error', 'Error', 'Failed to load zone details.', 3000);
    });
  }

  async patchZoneForm(zone: any) {
    const zoneBranch = zone.branch || zone.branchID;
    const zoneNodalPoints = Array.isArray(zone.nodalPoints) ? zone.nodalPoints : zone.nodalPoint;

    // Patch values into disabled controls
    this.zoneForm.patchValue({
      zoneName: zone.zoneName,
      branch: zoneBranch,
    });

    // Base nodalPoints from API data
    this.nodalPoints = Array.isArray(zoneNodalPoints)
      ? zoneNodalPoints.map((p: any) => ({
          area: p.name,
          location: {
            lat: p.location?.lat,
            lng: p.location?.lng,
            name: p.location?.name || ''
          }
        }))
      : [];

    // Fill missing location name via reverse-geocode (same behavior as edit-zone)
    for (let i = 0; i < this.nodalPoints.length; i++) {
      const loc = this.nodalPoints[i].location;
      if (loc && loc.lat != null && loc.lng != null && !loc.name) {
        const obj = {
          params: {
            latlng: `${loc.lat},${loc.lng}`
          }
        };
        try {
          const res: any = await this.api.transportManagerGoogleMapGeocoder(obj);
          if (res && res.status === 'success' && res.data) {
            try {
              const parsed = JSON.parse(res.data);
              const name = parsed?.results?.[0]?.formatted_address || '';
              if (name) {
                this.nodalPoints[i].location.name = name;
              }
            } catch (e) {
              console.log('Error parsing geocoder response:', e);
            }
          }
        } catch (err) {
          console.log('Geocoder error for nodal point:', err);
        }
      }
    }
  }

  /* Cancel */
  cancel() {
    this.router.navigate(['/organization/transport-manager/information/orgInfo/zone/view-zone']);
  }
}
